import React, { useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import PendingChangeWrapperCDS from 'app/shared/componentsRestyled/coreDesignSystem/PendingChangeWrapperCDS';
import StatusIconCDS from 'app/shared/componentsRestyled/coreDesignSystem/StatusIconCDS';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';
import { getChecklistResultStatus } from 'utils/checklist';

import { getStatusIconPendingChangeWrapperProps } from '../Alerts.utils';
import OverridePlaceholder from '../OverridePlaceholder';

import {
  categoryActionCellStyles,
  categoryActionDateCellStyles,
  categoryStatusCellStyles,
  categoryStatusOverlayStyles,
} from './ChecklistCategoryAccordion.styles';

const AdditionalSummaryContent = ({ category, statusDisplayType }) => {
  const {
    iconType: statusIconType,
    text: statusText,
    textColor: statusTextColor,
  } = getChecklistResultStatus({
    state: category.state,
    result: category.result,
    statusDisplayType,
  });

  const statusIconPendingChangeWrapperProps = useMemo(
    () => getStatusIconPendingChangeWrapperProps(category.isPendingChange),
    [category.isPendingChange],
  );

  return (
    <Box sx={categoryStatusOverlayStyles}>
      <Box sx={categoryStatusCellStyles}>
        <PendingChangeWrapperCDS {...statusIconPendingChangeWrapperProps}>
          <StatusIconCDS size={IconSize[24]} type={statusIconType} />
        </PendingChangeWrapperCDS>
        {statusText && (
          <Typography color={statusTextColor} variant="medium14">
            {statusText}
          </Typography>
        )}
      </Box>
      <Box sx={categoryActionDateCellStyles}>
        <OverridePlaceholder />
      </Box>
      <Box sx={categoryActionCellStyles} />
    </Box>
  );
};

AdditionalSummaryContent.propTypes = {
  category: PropTypes.object.isRequired,
  statusDisplayType: PropTypes.string.isRequired,
};

export default AdditionalSummaryContent;
